import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, Users, ClipboardList, History, LogOut, MapPin, KeyRound } from 'lucide-react';
import { Button } from '../components/ui/button';

const navItems = [
  { key: 'overview', label: 'Overview', icon: LayoutDashboard, path: '/admin' },
  { key: 'employees', label: 'Accounts', icon: Users, path: '/admin/employees' },
  { key: 'clients', label: 'Clients', icon: ClipboardList, path: '/admin/clients' },
  { key: 'logins', label: 'Logins', icon: MapPin, path: '/admin/logins' },
  { key: 'audit', label: 'Audit', icon: History, path: '/admin/audit' },
];

export function AdminHeader() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <header className="bg-white border-b border-[#E5E5EA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <Link to="/admin" className="shrink-0">
          <img src="/logo.png" alt="Payal Garg" className="h-7 sm:h-8 w-auto" />
        </Link>
        <div className="flex items-center gap-1.5">
          <Link to="/dashboard">
            <Button size="sm" className="bg-[#1C1C1E] text-white hover:bg-[#2C2C2E] rounded-full text-[11px] h-7 px-3" data-testid="go-dashboard-btn">Dashboard</Button>
          </Link>
          <Link to="/admin/settings">
            <Button variant="ghost" size="sm" className="text-[#8E8E93] rounded-full h-7 w-7 p-0" data-testid="admin-settings-btn">
              <KeyRound className="w-3.5 h-3.5" strokeWidth={1.5} />
            </Button>
          </Link>
          <Button data-testid="admin-logout-btn" variant="ghost" size="sm" className="text-[#8E8E93] hover:text-red-500 rounded-full h-7 w-7 p-0"
            onClick={async () => { await logout(); navigate('/'); }}>
            <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} />
          </Button>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto pb-0 -mb-px">
        {navItems.map((item) => (
          <Link key={item.key} to={item.path} data-testid={`admin-nav-${item.key}`}
            className={`flex items-center gap-1.5 px-3 sm:px-4 py-2 text-[13px] font-medium transition-all whitespace-nowrap ${
              location.pathname === item.path
                ? 'text-[#1C1C1E] border-b-2 border-[#1C1C1E]'
                : 'text-[#8E8E93] hover:text-[#1C1C1E]'
            }`}>
            <item.icon className="w-4 h-4" strokeWidth={1.5} />
            {item.label}
          </Link>
        ))}
      </div>
    </header>
  );
}
